
// Local
import ReactJsonLogic from './components/Master'

export default ReactJsonLogic
